<script setup lang="ts">
const { content, initialValues, step = 1 } = defineProps<{
  step?: number
  content?: any
  initialValues?: any
}>()

const id = Symbol('id').toString()
const state = useFormState(id)
state.value.activeStep = step

const stepsContent = isArray(content) ? content.flat() : content

const slots = useSlots().default()
const stepComponents = slots.map((item, index) => {
  const stepNumber = index + 1
  item.props = {
    ...item.props,
    id,
    initialValues: useOmitBy(initialValues, isNil),
    content: stepsContent[index] || content,
    step: stepNumber,
    fields: stepsContent[index]?.fields || content?.fields,
    last: slots.length === stepNumber,
  }
  return item
})
</script>

<template>
  <div>
    <component :is="stepComponent" v-for="(stepComponent, index) in stepComponents" :key="index" class="not-last:border-b-1" />
  </div>
</template>
